// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1CpEP","choiceBoxes":"toolbarselects_choiceBoxes__38tlZ","simpleField":"toolbarselects_simpleField__2EOM7"};